(function () {
  'use strict';

  var VARIANT_ID = 48468248395995;
  var SKU        = 'SHIP-PROTECT';

  var isUpdating = false;

  window._fcdProtectionSyncing = false;

  window._fcdProtectionBusy = function () {
    return isUpdating;
  };

  window._fcdTriggerProtectionSync = function (providedCart) {
    return runSyncPass(providedCart).catch(function (err) {
      console.warn('[ShipProtect] sync error:', err);
    });
  };

  function setSyncing(state) {
    window._fcdProtectionSyncing = state;
    isUpdating = state;
  }

  function getProtectionItem(cart) {
    if (!cart || !cart.items) return null;
    return cart.items.find(function (i) { return i.sku === SKU; });
  }

  function getNonProtectionItems(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (i) { return i.sku !== SKU; });
  }

  function calculateRequiredQty(cart) {
    var subtotal = getNonProtectionItems(cart).reduce(function (sum, i) {
      return sum + (i.line_price || 0);
    }, 0);
    return subtotal <= 0 ? 0 : Math.ceil(subtotal / 10000);
  }

  function clearOptedOutFlag() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { protection_opted_out: '' } })
    }).catch(function () {});
  }

  function runSyncPass(providedCart) {
    setSyncing(true);

    var cartPromise;
    if (providedCart && Array.isArray(providedCart.items)) {
      cartPromise = Promise.resolve(providedCart);
    } else {
      cartPromise = fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart fetch failed: ' + r.status);
          return r.json();
        });
    }

    return cartPromise
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) {
          throw new Error('Invalid cart');
        }

        window._fcdCart = cart;

        var nonProtection  = getNonProtectionItems(cart);
        var protectionItem = getProtectionItem(cart);
        var requiredQty    = calculateRequiredQty(cart);
        var currentQty     = protectionItem ? protectionItem.quantity : 0;

        // Case 1: cart has no real items — remove protection if present.
        if (nonProtection.length === 0) {
          if (protectionItem) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: protectionItem.key, quantity: 0 })
            }).then(function (r) { return r.json(); }).then(function (updated) {
              if (updated && Array.isArray(updated.items)) {
                window._fcdCart = updated;
              }
            });
          }
          return;
        }

        // Case 2: protection already at correct qty — nothing to change.
        if (requiredQty === currentQty) {
          return;
        }

        // Case 3: need to update protection.
        var endpoint = protectionItem ? '/cart/change.js' : '/cart/add.js';
        var body     = protectionItem
          ? { id: protectionItem.key, quantity: requiredQty }
          : { id: VARIANT_ID, quantity: requiredQty };

        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) throw new Error('Cart update failed: ' + r.status);
          return r.json();
        }).then(function (updated) {
          if (updated && Array.isArray(updated.items)) {
            window._fcdCart = updated;

            // Clear opted-out flag when protection is successfully added.
            clearOptedOutFlag();

            // VERIFY: after the POST, protection should now be at requiredQty.
            // If not (edge case: cart changed again during the POST), re-sync.
            var newProt = getProtectionItem(updated);
            var newRequired = calculateRequiredQty(updated);
            var newActual = newProt ? newProt.quantity : 0;
            if (newRequired !== newActual) {
              return runSyncPassInternal(updated);
            }
          }
        });
      })
      .finally(function () {
        setSyncing(false);
      });
  }

  // Internal re-sync without the isUpdating flag dance.
  function runSyncPassInternal(cart) {
    var nonProtection  = getNonProtectionItems(cart);
    var protectionItem = getProtectionItem(cart);
    var requiredQty    = calculateRequiredQty(cart);
    var currentQty     = protectionItem ? protectionItem.quantity : 0;

    if (nonProtection.length === 0 || requiredQty === currentQty) return;

    var endpoint = protectionItem ? '/cart/change.js' : '/cart/add.js';
    var body     = protectionItem
      ? { id: protectionItem.key, quantity: requiredQty }
      : { id: VARIANT_ID, quantity: requiredQty };

    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (updated) {
      if (updated && Array.isArray(updated.items)) {
        window._fcdCart = updated;
      }
    });
  }

  window._fcdEnsureProtectionSettled = function () {
    return runSyncPass().catch(function (err) {
      console.warn('[ShipProtect] settle:', err);
    });
  };

  // Safety net: if a cart mutation happens outside our cart-drawer (e.g.,
  // subscription update, third-party script), sync protection after.
  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    var result = originalFetch.apply(this, arguments);

    if (
      typeof url === 'string' &&
      (url.indexOf('/cart/add') !== -1 ||
       url.indexOf('/cart/change') !== -1 ||
       url.indexOf('/cart/update') !== -1 ||
       url.indexOf('/cart/clear') !== -1)
    ) {
      var body = (options && options.body) ? String(options.body) : '';
      var isProtectionUpdate  = body.indexOf(String(VARIANT_ID)) !== -1 || body.indexOf(SKU) !== -1;
      var isSellingPlanUpdate = body.indexOf('selling_plan') !== -1;

      if (!isProtectionUpdate && !isSellingPlanUpdate && !isUpdating) {
        setTimeout(function () {
          if (!isUpdating) {
            fetch('/cart.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (fresh) {
                if (fresh && Array.isArray(fresh.items)) {
                  window._fcdCart = fresh;
                  var required = calculateRequiredQty(fresh);
                  var protItem = getProtectionItem(fresh);
                  var current = protItem ? protItem.quantity : 0;
                  if (required !== current) {
                    runSyncPass(fresh).then(function () {
                      if (typeof window.fcdRenderCart === 'function' && window._fcdCart) {
                        window.fcdRenderCart(window._fcdCart);
                      }
                    }).catch(function (err) { console.warn('[ShipProtect] safety-net:', err); });
                  } else {
                    if (typeof window.fcdRenderCart === 'function') {
                      window.fcdRenderCart(fresh);
                    }
                  }
                }
              })
              .catch(function () {});
          }
        }, 250);
      }
    }

    return result;
  };

  function initialSync() {
    setTimeout(function () {
      runSyncPass().then(function () {
        if (typeof window.fcdRenderCart === 'function' && window._fcdCart) {
          window.fcdRenderCart(window._fcdCart);
        }
      }).catch(function (err) { console.warn('[ShipProtect] initial:', err); });
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }

})();a